/* ── CURSOR ── */
const cursor = document.getElementById('cursor');
const ring   = document.getElementById('cursor-ring');
if (cursor && ring) {
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove', e => { mx=e.clientX; my=e.clientY; });
  (function tick(){
    cursor.style.left = mx-5+'px'; cursor.style.top = my-5+'px';
    rx += (mx-rx)*0.15; ry += (my-ry)*0.15;
    ring.style.left = rx-16+'px'; ring.style.top = ry-16+'px';
    requestAnimationFrame(tick);
  })();
  document.querySelectorAll('a,button,.space-card,.home-card').forEach(el => {
    el.addEventListener('mouseenter', () => { cursor.style.transform='scale(2.2)'; ring.style.transform='scale(1.4)'; ring.style.borderColor='rgba(240,237,232,0.8)'; });
    el.addEventListener('mouseleave', () => { cursor.style.transform='scale(1)';   ring.style.transform='scale(1)';   ring.style.borderColor='rgba(240,237,232,0.4)'; });
  });
}

/* ── NAV SCROLL ── */
window.addEventListener('scroll', () => {
  const nav = document.getElementById('navbar');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
});

/* ── MOBILE MENU ── */
function toggleMobileMenu() {
  const menu   = document.getElementById('mobileMenu');
  const burger = document.getElementById('hamburger');
  if (!menu||!burger) return;
  const open = menu.classList.toggle('open');
  burger.classList.toggle('open', open);
  burger.setAttribute('aria-expanded', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
function closeMobileMenu() {
  const menu   = document.getElementById('mobileMenu');
  const burger = document.getElementById('hamburger');
  if (!menu||!burger) return;
  menu.classList.remove('open');
  burger.classList.remove('open');
  burger.setAttribute('aria-expanded','false');
  document.body.style.overflow = '';
}

/* ── CART ── */
const cartDrawer  = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');

function openCart()  {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');  cartDrawer.setAttribute('aria-hidden','false');
  cartOverlay.classList.add('open'); cartOverlay.setAttribute('aria-hidden','false');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');  cartDrawer.setAttribute('aria-hidden','true');
  cartOverlay.classList.remove('open'); cartOverlay.setAttribute('aria-hidden','true');
  document.body.style.overflow = '';
}

const cartToggle = document.getElementById('cartToggle');
const cartClose  = document.getElementById('cartClose');
if (cartToggle) cartToggle.addEventListener('click', openCart);
if (cartClose)  cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const c = document.getElementById('cartCount');
      if (c) {
        const prev = c.textContent;
        c.textContent = cart.item_count;
        if (prev !== String(cart.item_count)) {
          c.classList.remove('se-pop');
          void c.offsetWidth; /* restart animation */
          c.classList.add('se-pop');
        }
      }
      renderCartItems(cart);
    })
    .catch(e => console.error('Cart fetch:', e));
}
window.refreshCart = refreshCart;

function formatMoney(cents) {
  var n = Number(cents);
  if (!isFinite(n)) n = 0;
  return '₹' + (n / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

function renderCartItems(cart) {
  const itemsEl  = document.getElementById('cartItems');
  const emptyEl  = document.getElementById('cartEmpty');
  const footerEl = document.getElementById('cartFooter');
  const subEl    = document.getElementById('cartSubtotal');
  if (!itemsEl) return;

  if (!cart.item_count) {
    itemsEl.innerHTML = '';
    if (emptyEl) { emptyEl.style.display='block'; itemsEl.appendChild(emptyEl); }
    if (footerEl) footerEl.style.display = 'none';
    return;
  }
  if (emptyEl)  emptyEl.style.display  = 'none';
  if (footerEl) footerEl.style.display = 'block';

  /* robust subtotal: use cart total, fall back to summing line prices */
  var total = Number(cart.total_price);
  if (!isFinite(total)) {
    total = (cart.items || []).reduce(function (s, i) { return s + (Number(i.final_line_price) || 0); }, 0);
  }
  if (subEl) subEl.textContent = formatMoney(total);

  itemsEl.innerHTML = cart.items.map(function (item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-item-variant">' + item.variant_title.toUpperCase() + '</div>' : '';
    var img = item.image
      ? '<img class="cart-item-img" src="' + item.image + '" alt="' + item.product_title + '" width="72" height="90" loading="lazy"/>'
      : '<div class="cart-item-img-placeholder">SE</div>';
    return '<div class="cart-item">' + img +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + item.product_title.toUpperCase() + '</div>' + variant +
        '<div class="cart-item-price">' + formatMoney(item.final_price) + ' each</div>' +
        '<div class="cart-qty">' +
          '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + item.quantity + '" data-act="dec" aria-label="Decrease quantity">−</button>' +
          '<span class="qty-num">' + item.quantity + '</span>' +
          '<button type="button" class="qty-btn" data-key="' + item.key + '" data-qty="' + item.quantity + '" data-act="inc" aria-label="Increase quantity">+</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove">✕</button>' +
    '</div>';
  }).join('');
}

function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => r.json()).then(cart => {
    renderCartItems(cart);
    const c = document.getElementById('cartCount');
    if (c) c.textContent = cart.item_count;
  }).catch(e => console.error('Remove item:', e));
}

/* delegated click handler — survives re-renders, works on mobile */
(function () {
  var itemsEl = document.getElementById('cartItems');
  if (!itemsEl) return;
  itemsEl.addEventListener('click', function (e) {
    var rm = e.target.closest('.cart-item-remove');
    if (rm && rm.dataset.key) { e.preventDefault(); removeItem(rm.dataset.key); return; }
    var q = e.target.closest('.qty-btn');
    if (q && q.dataset.key) {
      e.preventDefault();
      var cur = parseInt(q.dataset.qty, 10) || 1;
      var next = q.dataset.act === 'inc' ? cur + 1 : cur - 1;
      changeQty(q.dataset.key, Math.max(next, 0));
    }
  });
})();

function changeQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(r => r.json()).then(cart => {
    renderCartItems(cart);
    const c = document.getElementById('cartCount');
    if (c) c.textContent = cart.item_count;
  }).catch(e => console.error('Change qty:', e));
}

/* ── SPACE PRODUCTS (collection page) ── */
const spaceContainer = document.getElementById('productSpace');
if (spaceContainer) {
  // lazy load space video
  const sv = document.getElementById('spaceVideo');
  const sf = document.getElementById('spaceFallback');
  if (sv) {
    sv.addEventListener('error', () => { sv.style.display='none'; if(sf) sf.classList.add('visible'); });
    sv.load(); sv.play().catch(()=>{});
  }

  let nodes=[], raf=null;

  function init() {
    const cards = document.querySelectorAll('.space-card');
    nodes = [];
    const W = window.innerWidth, H = window.innerHeight;
    const cw = W < 768 ? 130 : 180;
    const ch = cw * 1.45;

    cards.forEach((el, i) => {
      const m = 24;
      const x = m + Math.random() * (W - cw - m*2);
      const y = 72 + m + Math.random() * (H - ch - m*2 - 72);
      const a = Math.random() * Math.PI * 2;
      const sp = 0.18 + Math.random() * 0.22;
      const rv = (Math.random()-0.5)*0.008;

      el.addEventListener('click', () => openModal(el));
      el.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' ') openModal(el); });
      el.addEventListener('touchstart', e => {
        e.preventDefault();
        el.classList.add('touched');
        setTimeout(()=>{ el.classList.remove('touched'); openModal(el); }, 160);
      }, {passive:false});

      const node = { el, x, y, vx:Math.cos(a)*sp, vy:Math.sin(a)*sp, rot:Math.random()*20-10, rv, w:cw, h:ch, paused:false };
      el.addEventListener('mouseenter', ()=>{ node.paused=true; });
      el.addEventListener('mouseleave', ()=>{ node.paused=false; });
      nodes.push(node);
    });
    if (raf) cancelAnimationFrame(raf);
    tick();
  }

  function tick() {
    const W=window.innerWidth, H=window.innerHeight;
    nodes.forEach(n => {
      if (n.paused) return;
      n.x+=n.vx; n.y+=n.vy; n.rot+=n.rv;
      if (n.x<0)       { n.x=0;       n.vx= Math.abs(n.vx); }
      if (n.x+n.w>W)   { n.x=W-n.w;  n.vx=-Math.abs(n.vx); }
      if (n.y<64)      { n.y=64;      n.vy= Math.abs(n.vy); }
      if (n.y+n.h>H)   { n.y=H-n.h;  n.vy=-Math.abs(n.vy); }
      if (n.rot> 12) n.rv=-Math.abs(n.rv);
      if (n.rot<-12) n.rv= Math.abs(n.rv);
      n.el.style.transform = `translate(${n.x}px,${n.y}px) rotate(${n.rot}deg)`;
    });
    raf = requestAnimationFrame(tick);
  }

  window.addEventListener('resize', init);
  init();

  /* MODAL */
  const modalOverlay = document.getElementById('productModal');
  const modalClose   = document.getElementById('modalClose');
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalOverlay) modalOverlay.addEventListener('click', e => { if(e.target===modalOverlay) closeModal(); });
  document.addEventListener('keydown', e => { if(e.key==='Escape') closeModal(); });

  function openModal(el) {
    if (!modalOverlay) return;
    document.getElementById('modalTag').textContent   = (el.dataset.tag||'STREETWEAR').toUpperCase();
    document.getElementById('modalName').textContent  = (el.dataset.title||'').toUpperCase();
    document.getElementById('modalPrice').textContent = el.dataset.price||'';
    document.getElementById('modalDesc').textContent  = el.dataset.desc||'';
    document.getElementById('modalViewLink').href     = el.dataset.url||'#';

    const mImg = document.getElementById('modalImg');
    if (el.dataset.img) {
      mImg.innerHTML = `<img src="${el.dataset.img}" alt="${el.dataset.title||''}" style="width:100%;height:100%;object-fit:cover;"/>`;
    } else {
      mImg.textContent = 'SE';
      mImg.style.background = el.dataset.color||'var(--surface)';
    }

    // sizes
    const sizesEl  = document.getElementById('modalSizes');
    const sizesRaw = el.dataset.sizes||'';
    if (sizesRaw) {
      try {
        const sizes = JSON.parse(sizesRaw);
        sizesEl.innerHTML = sizes.map(s =>
          `<button class="size-btn${s.available===false?' disabled':''}" data-variant="${s.id}" onclick="selectModalSize(this)"${s.available===false?' disabled':''}>
            ${s.title}
          </button>`).join('');
      } catch(e) { sizesEl.innerHTML=''; }
    } else {
      sizesEl.innerHTML = '';
    }

    modalOverlay.dataset.variantId = el.dataset.id||'';
    document.getElementById('modalSizeError').style.display = 'none';
    modalOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (modalOverlay) { modalOverlay.classList.remove('open'); document.body.style.overflow=''; }
  }
  window.closeModal = closeModal;

  window.selectModalSize = function(btn) {
    document.querySelectorAll('#modalSizes .size-btn').forEach(b=>b.classList.remove('selected'));
    btn.classList.add('selected');
    if (modalOverlay) modalOverlay.dataset.variantId = btn.dataset.variant;
    document.getElementById('modalSizeError').style.display = 'none';
  };

  const modalAddBtn = document.getElementById('modalAddBtn');
  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', () => {
      const sizeBtns = document.querySelectorAll('#modalSizes .size-btn');
      if (sizeBtns.length > 0 && !document.querySelector('#modalSizes .size-btn.selected')) {
        document.getElementById('modalSizeError').style.display = 'block';
        return;
      }
      const selected = document.querySelector('#modalSizes .size-btn.selected');
      const vid = selected ? selected.dataset.variant : modalOverlay.dataset.variantId;
      if (!vid) return;

      modalAddBtn.textContent = 'ADDING...';
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: vid, quantity:1})
      }).then(r=>r.json()).then(()=>{
        modalAddBtn.textContent = 'ADD TO BAG';
        closeModal();
        refreshCart();
        openCart();
      }).catch(e => { console.error('Add to cart:', e); modalAddBtn.textContent='ADD TO BAG'; });
    });
  }
}

/* ── CONTACT FORM ── */
const contactForm = document.getElementById('contactForm');
if (contactForm) {
  contactForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = contactForm.querySelector('.form-submit');
    btn.textContent = 'SENDING...';
    fetch('https://formspree.io/f/mnjyzold', {
      method:'POST', body: new FormData(contactForm),
      headers:{'Accept':'application/json'}
    }).then(r => {
      if (r.ok) {
        contactForm.reset();
        btn.textContent = 'SEND IT →';
        const s = document.getElementById('formSuccess');
        if (s) { s.style.display='block'; setTimeout(()=>s.style.display='none',5000); }
      } else { btn.textContent = 'SEND IT →'; }
    }).catch(()=>{ btn.textContent = 'SEND IT →'; });
  });
}

/* ── SCROLL REVEAL (site-wide) ── */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const sels = [
    '.policy-block', '.exchange-header', '.exchange-flow',
    '.about-left h1', '.about-left p', '.stat-block', '.about-manifesto',
    '.contact-info-item', '.contact-form',
    '.product-description', '.product-meta',
    '.returns-hero', '.cart-page-items .cart-item', '.cart-page-footer',
    '.section-header', '.home-card', '.home-statement',
    'footer .footer-brand', 'footer .footer-col'
  ].join(',');
  const els = document.querySelectorAll(sels);
  if (!els.length) return;
  els.forEach((el, i) => {
    el.classList.add('se-rv');
    el.style.transitionDelay = (i % 5) * 70 + 'ms';
  });
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('se-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
  els.forEach(el => io.observe(el));
})();

/* ── STAT COUNT-UP (about page) ── */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const nums = document.querySelectorAll('.stat-num');
  if (!nums.length) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target;
      const raw = el.textContent.trim();
      const target = parseInt(raw, 10);
      if (isNaN(target)) return;             /* leaves ∞ etc. alone */
      const suffix = raw.replace(/^[0-9]+/, '');
      const t0 = performance.now(), dur = 1300;
      requestAnimationFrame(function step(t) {
        const p = Math.min((t - t0) / dur, 1);
        const ease = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * ease) + suffix;
        if (p < 1) requestAnimationFrame(step);
      });
    });
  }, { threshold: 0.5 });
  nums.forEach(el => io.observe(el));
})();

/* ── INIT CART COUNT ── */
refreshCart();
